import { render, staticRenderFns } from "./TrainingVideosSectionsEditor.vue?vue&type=template&id=8009972e&scoped=true&"
import script from "./TrainingVideosSectionsEditor.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosSectionsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8009972e",
  null
  
)

export default component.exports